import { inject, injectable } from "inversify";
import { CountryCodeModel, ICPLTypesClient } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface ICountriesService {
  getCountries(): Promise<CountryCodeModel[]>;
}

@injectable()
export class CountriesService implements ICountriesService {
  @inject(SERVICE_TYPES.CPLTypesClient) cplTypesClient!: ICPLTypesClient;

  async getCountries(): Promise<CountryCodeModel[]> {
    return this.cplTypesClient.getCountries();
  }
}
